module.exports = __webpack_public_path__ + "static/media/telemedicine_doctor_f.7434a5e9.png";